import { onUnmounted, watch } from 'vue';
import { MdTypography, MdModal, MdButton, MdIconLoader, MdSpinner } from '@antiqua-dls/vue-components';
import { disableScrollOnModalOpen } from 'src/utils/helper/misc';

export default {
  name: 'ConfirmationModal',
  components: {
    MdModal,
    MdTypography,
    MdButton,
    MdIconLoader,
    MdSpinner
  },
  props: {
    modalId: {
      type: String,
      default: ''
    },
    modalHeader: {
      type: String,
      default: ''
    },
    modalDescription: {
      type: String,
      default: ''
    },
    modalSecondaryButtonText: {
      type: String,
      default: ''
    },
    modalPrimaryButtonText: {
      type: String,
      default: ''
    },
    isModalOpen: {
      type: Boolean,
      default: false
    },
    primaryButtonColor: {
      type: String,
      default: 'primary'
    },
    closeModal: {
      type: Function,
      default: () => { }
    },
    handleAction: {
      type: Function,
      default: () => { }
    },
    showLoaderInPrimaryButton: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeModal', 'handleAction'],
  setup(props) {

    onUnmounted(() => {
      disableScrollOnModalOpen(false)
    })

    watch(() => props.isModalOpen, () => {
      disableScrollOnModalOpen(props.isModalOpen)
    })

    return {
    }
  }
};
